import { ReactNode } from 'react';
import clsx from 'clsx';

import styles from './filters.module.scss';

type WidgetFilterContainerProps = {
  children: ReactNode;
  withBottomBorder?: boolean;
};
export function WidgetFilterContainer({
  children,
  withBottomBorder,
}: WidgetFilterContainerProps) {
  return (
    <div
      className={clsx(styles['container'], styles['container__widget'], {
        [styles['container__bottom-border']]: withBottomBorder,
      })}
    >
      {children}
    </div>
  );
}
